import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import unroutedEndpoint from "./unroutedEndpoint";

const API_URL = config.API_URL;

const positiveInteger = (value) => {
  const integer = Number(value);
  return Number.isInteger(integer) && integer > 0 ? integer : null;
};

const queryValueFromLegacyUrl = (url, key) => {
  if (typeof url !== "string" || !url) return null;

  try {
    return new URL(url, "https://notification-list.invalid").searchParams.get(key);
  } catch (_error) {
    return null;
  }
};

const notificationListRequest = (values = {}) => {
  const input = values && typeof values === "object" ? values : {};
  const id = positiveInteger(input.id);
  const page = positiveInteger(input.page) || positiveInteger(queryValueFromLegacyUrl(input.next_page_url, "page"));
  const limit = positiveInteger(input.limit) || positiveInteger(queryValueFromLegacyUrl(input.next_page_url, "limit"));
  const pagination = input.pagination !== undefined ? Boolean(input.pagination) : !id && !input.option;
  const params = new URLSearchParams();

  if (pagination && page) params.set("page", String(page));

  const body = { pagination };
  if (pagination && limit) body.limit = limit;
  if (id) body.id = id;
  if (typeof input.type === "string" && input.type.trim()) body.type = input.type.trim();

  const query = params.toString();
  return {
    url: `afterlogin/notification/view${query ? `?${query}` : ""}`,
    body,
  };
};

const notifylistview = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/notifydetail/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    notifydata:values.notifydata
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const notifyupdate = (values) => {
  if (!values || !values.id) {
    // Flask exposes notification settings as update/isactive only; there is
    // there is no notification-setting create route in the Flask contract.
    return unroutedEndpoint("afterlogin/notifydetail/store", "afterlogin/notifydetail/update/<id>");
  }
  const action = "afterlogin/notifydetail/update/" + values.id;
  // Notification settings are JSON contracts in Flask.  Sending FormData here
  // makes request.get_json() empty and the server quite correctly rejects the
  // update as missing title/channel/type fields.
  const body = { ...values || {} };
  delete body["auth_key"];
  delete body["action"];
  return axios.post(API_URL + action, body, { headers: authHeader() });
};

const notifyisactive = (values) => {
  const action = "afterlogin/notifydetail/isactive/" + values.id;
  const body = {};
  if (values && Object.prototype.hasOwnProperty.call(values, "is_active")) {
    body.is_active = values.is_active;
  }
  return axios.post(API_URL + action, body, { headers: authHeader() });
};

const notificationlist = (values) => {
  const request = notificationListRequest(values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const notificationupdate = (values) => {
  const action = "afterlogin/notification/update/" + values.id;
  const body = {};
  if (values && Object.prototype.hasOwnProperty.call(values, "is_seen")) {
    body.is_seen = values.is_seen;
  }
  return axios.post(API_URL + action, body, { headers: authHeader() });
};

const clearall = () => {
  const action = "afterlogin/notification/deleteall";
  return axios.post(API_URL + action, {}, { headers: authHeader(), deleteConfirmation: false });
};

const markasread = () => {
  const action = "afterlogin/notification/readall";
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};

const notificationcounts = () => {
  const action = "afterlogin/notification/notificationcount";
  return axios.post(API_URL + action, {}, { headers: authHeader() });
};

const notifydetails = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/notifydetail/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    pagination: false, //true or false
    notifydata:values.notifydata,
    id:values && values.id ? values.id : ""
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const notificationApiController = {
  notifylistview,
  notifyupdate,
  notifyisactive,
  notificationlist,
  notificationupdate,
  clearall,
  markasread,
  notificationcounts,
  notifydetails
};

export default notificationApiController;
